// Utilities for Add-to-Google-Calendar and .ics download

export function googleCalendarUrl(event) {
    const params = new URLSearchParams({
        action: "TEMPLATE",
        text: `${event.title} — Rayyan & Zuha`,
        details: event.description || "",
        location: `${event.venueName}, ${event.venueAddress}`,
        dates: `${event.startISO}/${event.endISO}`,
    });
    return `https://calendar.google.com/calendar/render?${params.toString()}`;
}

function toIcsDate(iso) {
    // iso like 20260815T193000 (local) — treat as floating time
    return iso;
}

export function buildIcs(event) {
    const uid = `${event.id}-${event.startISO}@rayyan-zuha`;
    const dtstamp =
        new Date()
            .toISOString()
            .replace(/[-:]/g, "")
            .replace(/\.\d{3}/, "") + "";
    return [
        "BEGIN:VCALENDAR",
        "VERSION:2.0",
        "PRODID:-//Rayyan Zuha Wedding//EN",
        "CALSCALE:GREGORIAN",
        "METHOD:PUBLISH",
        "BEGIN:VEVENT",
        `UID:${uid}`,
        `DTSTAMP:${dtstamp}`,
        `DTSTART:${toIcsDate(event.startISO)}`,
        `DTEND:${toIcsDate(event.endISO)}`,
        `SUMMARY:${event.title} — Rayyan & Zuha`,
        `DESCRIPTION:${(event.description || "").replace(/\n/g, "\\n")}`,
        `LOCATION:${event.venueName}, ${event.venueAddress}`,
        "END:VEVENT",
        "END:VCALENDAR",
    ].join("\r\n");
}

export function downloadIcs(event) {
    const blob = new Blob([buildIcs(event)], {
        type: "text/calendar;charset=utf-8",
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `${event.id}-rayyan-zuha.ics`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    setTimeout(() => URL.revokeObjectURL(url), 1000);
}
